$(document).ready(function() {

  $.shifter({
    maxWidth: "740px"
  });

  // Call Fancybox globally on all elements with class fancybox
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

  $('.flexslider').flexslider({
    animation: "fade",
    controlNav: true,
    slideshowSpeed: 1000,
    directionNav: true
  });

  $('.coll-filter').customSelect();

  

  // Highlight the current sidebar link
  //<![CDATA[
  jQuery(function() {
    jQuery('#sidebar ul li a').each(function() {
      if (
        jQuery(this).attr('href') ===
        window.location.pathname
      ) {
        jQuery(this).addClass('current');
      }
    });
  });
  //]]>

  /*
    Remember which mobile submenu was open.
  */
  var mobileMenuStateKey = 'distalMobileMenuPanel';

  /*
    Open a mobile submenu.
  */
  $('.shifter-navigation').on(
    'click',
    '[data-menu-target]',
    function(event) {
      event.preventDefault();

      var $navigation = $(this).closest(
        '.shifter-navigation'
      );

      var targetPanel = $(this).attr(
        'data-menu-target'
      );

      $navigation.find('.mobile-menu-panel')
        .removeClass('is-active');

      $navigation.find('#' + targetPanel)
        .addClass('is-active');

      $navigation.find('[data-menu-target]')
        .attr('aria-expanded', 'false');

      $(this).attr('aria-expanded', 'true');

      sessionStorage.setItem(
        mobileMenuStateKey,
        targetPanel
      );
    }
  );

  /*
    Return to the main mobile menu.
  */
  $('.shifter-navigation').on(
    'click',
    '[data-menu-back]',
    function() {
      var $navigation = $(this).closest(
        '.shifter-navigation'
      );

      $navigation.find('.mobile-menu-panel')
        .removeClass('is-active');

      $navigation
        .find('[data-menu-panel="root"]')
        .addClass('is-active');

      $navigation.find('[data-menu-target]')
        .attr('aria-expanded', 'false');

      sessionStorage.setItem(
        mobileMenuStateKey,
        'root'
      );
    }
  );

  /*
    Restore the submenu after returning from a collection page.
  */
  var savedMobileMenuPanel =
    sessionStorage.getItem(mobileMenuStateKey);

  if (savedMobileMenuPanel) {
    var $navigation = $('.shifter-navigation');
    var $savedPanel;

    if (savedMobileMenuPanel === 'root') {
      $savedPanel = $navigation.find(
        '[data-menu-panel="root"]'
      );
    } else {
      $savedPanel = $navigation.find(
        '#' + savedMobileMenuPanel
      );
    }

    if ($savedPanel.length) {
      $navigation.find('.mobile-menu-panel')
        .removeClass('is-active');

      $savedPanel.addClass('is-active');

      $navigation.find('[data-menu-target]')
        .attr('aria-expanded', 'false');

      $navigation.find('[data-menu-target]').filter(
        function() {
          return $(this).attr(
            'data-menu-target'
          ) === savedMobileMenuPanel;
        }
      ).attr('aria-expanded', 'true');
    }
  }

});